import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, type LegalSection } from "@/components/legal/legal-layout";
import { usePolicy } from "@/lib/policies-store";
import { renderPolicyBody } from "@/lib/render-policy";
import { useLocalizedPolicy } from "@/lib/use-localized-policy";

export const Route = createFileRoute("/cancellation")({
  head: () => ({
    meta: [
      { title: "Cancellation policy — Spayzo" },
      { name: "description", content: "Understand how cancellations, refunds and no-shows work on Spayzo." },
      { property: "og:title", content: "Cancellation policy — Spayzo" },
      { property: "og:description", content: "Clear, fair rules for changing or cancelling bookings." },
    ],
    links: [{ rel: "canonical", href: "https://spayzo.lovable.app/cancellation" }],
  }),
  component: CancellationPage,
});

function CancellationPage() {
  const doc = useLocalizedPolicy("cancellation", usePolicy("cancellation"));
  const sections: LegalSection[] = doc.sections.map((s) => ({
    id: s.id,
    title: s.title,
    body: renderPolicyBody(s.body),
  }));
  return (
    <LegalLayout
      title={doc.title}
      description={doc.description}
      updated={doc.updated}
      sections={sections}
      numbered={doc.numbered}
    />
  );
}
